import { SideBar } from '@equinor/eds-core-react';
import styled from 'styled-components';
import { theme } from '../../tokens/theme';

export const StyledSidebar = styled(SideBar)`
  align-self: stretch;
  overflow: hidden;
  height: 100%;

  & > div {
    overflow: hidden;
    height: 100%;
  }

  /* Force border-bottom on accordion items in collapsed mode */
  &:not([open]) [class*='SideBarAccordion__MenuItem'] {
    border-bottom: 2px solid ${theme.light.ui.background.light};
  }
`;

export const StyledBackButton = styled(SideBar.Link)`
  > p {
    color: ${theme.light.primary.resting};
    font-weight: bold;
  }
  > svg {
    fill: ${theme.light.primary.resting};
  }
  &:hover {
    background-color: ${theme.light.ui.background.light};
  }

  place-items: center;
`;
